import { render, staticRenderFns } from "./hqglOfficeVisitorReception.vue?vue&type=template&id=141c32fe&scoped=true&"
import script from "./hqglOfficeVisitorReception.vue?vue&type=script&lang=js&"
export * from "./hqglOfficeVisitorReception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141c32fe",
  null
  
)

export default component.exports